export const CURRENT_PRODUCT = "CURRENT_PRODUCT"
export const GET_BID_HISTORY = "GET_BID_HISTORY"
export const GET_BID_HISTORY_ALL = "GET_BID_HISTORY_ALL"
export const RESET_BID_HISTORY = "RESET_BID_HISTORY"
